import script from "./admin-empresas.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-empresas.vue?vue&type=script&setup=true&lang=js"

import "./admin-empresas.vue?vue&type=style&index=0&id=08117de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08117de4"]])

export default __exports__